import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import type { IMenuItem } from 'src/types/menu.types';
import { getItem } from '../../api/getItem/getItem';
import { QueryKeys } from '../QueryKeys';
import { formatItem } from './formatItem/formatItem';

export const useItem = (
  itemId: string,
  priceSchemeId?: string,
  options?: UseQueryOptions<IMenuItem>,
): UseQueryResult<IMenuItem> => {
  const { showSnackbar } = useSnackbar();
  return useQuery<IMenuItem>({
    queryKey: [QueryKeys.item, itemId, priceSchemeId],
    queryFn: async () => {
      const viewItem = await getItem(itemId, priceSchemeId || null);
      return formatItem(viewItem);
    },
    staleTime: 60000, // 1 minute
    onError: () => showSnackbar({ status: SnackbarStatus.ERROR, message: 'Something went wrong' }),
    cacheTime: 0,
    ...options,
  });
};
